export function removeQueryParamsFromUrl(url: string): string {
    if (typeof url === 'string') {
        return url.replace(/\?(\w+=(\d+|\w+)&?)+/g, '');
    } else {
        return url;
    }
}
